import { render } from "./CookieLaw.vue?vue&type=template&id=36fc9515"
import script from "./CookieLaw.vue?vue&type=script&lang=js"
export * from "./CookieLaw.vue?vue&type=script&lang=js"

import "./CookieLaw.vue?vue&type=style&index=0&id=36fc9515&lang=scss"
script.render = render

export default script